/* eslint-disable camelcase */
import jwt_decode from 'jwt-decode';

export default function updateLocalStorage({ data }) {
    localStorage.clear();
    const decodedToken = jwt_decode(data.access_token);

    // TODO Don't store these in local storage.
    // These should be set as cookies instead.
    localStorage.setItem('token', data.access_token);
    localStorage.setItem('refreshToken', data.refresh_token);
    // TODO Don't store these in local storage.
    // These two should not be set in local storage, bc that's a security risk.
    localStorage.setItem('exp', decodedToken.exp);
    localStorage.setItem('scope', decodedToken.scope);
}
